<palantir-content class="palantir-menu palantir-table-labels__menu">
  <div class="palantir-table-labels__menu--header">
    <palantir-text size="base" type="title">
      {{ title | translate }}
    </palantir-text>
  </div>

  <div class="palantir-table-labels__menu__content">
    <div class="palantir-table-labels__menu__content--item" *ngFor="let tag of tags">
      <palantir-tag
        [matTooltip]="tag"
        [matTooltipShowDelay]="500"
        [color]="'blue-grey'"
        [size]="'base'"
        [style]="'soft'"
        [shape]="'default'"
      >
        {{ tag }}
      </palantir-tag>
    </div>
  </div>
</palantir-content>
